import { t } from "@i18n";

export const entityTypes: any = [
  { id: "files", text: "Files" },
  { id: "estimates", text: "Estimates" },
  { id: "issues", text: "Issues" },
  { id: "tasks", text: "Tasks" },
  { id: "schedules", text: "Schedules" },
];

export const CHANGE_REASONS = {
  REMOVE_OPTION: "removeOption",
  CLEAR: "clear",
};

export const defaultReviewData: any = {
  _id: "",
  name: "",
  reviewId: "",
  description: "",
  createdBy: {
    firstName: "",
    lastName: "",
  },
  createdDate: 131231311123,
  reviewStatus: "Open",
  workflow: {
    name: "First Workflow",
  },
  currentReviewLevel: {
    serial: 0,
    title: "Temp",
  },
};

export const defaultCreateReviewData: any = {
  name: "",
  description: "",
  workflow: { id: null },
  stage: 1,
  postCreationData: {
    selectedReviewersAtLevel1: [],
    selectedReviewersFromSpace: [],
    message: "",
    _id: null,
  },
};

export const defaultSignatureModalState: any = {
  show: false,
  resources: [],
  reviewId: null,
  statusFrom: {},
  statusTo: {},
  requireMandatoryComment: false,
};

export const markReviewMapper: any = {
  approve: {
    heading: t("Mark as Reviewed"),
    content: "Are you sure you want to mark as reviewed ?",
    successToast: "The review has been approved",
    failureDefaultToast: "The review could not be approved",
  },
  revoke: {
    heading: t("Revoke Review"),
    content: "Are you sure you want to revoke the selected review ?",
    successToast: "The review has been revoked",
    failureDefaultToast: "The review could not be revoked",
  },
  skip: {
    heading: t("Skip Review"),
    content: "Are you sure you want to skip the selected review ?",
    successToast: "The review has been skipped",
    failureDefaultToast: "The review could not be skipped",
  },
};

export const reviewStageMapper: any = {
  Draft: {
    name: "Draft",
    indicatorClass: "reviewStageDraftIndicator",
    containerClass: "reviewStageDraft",
  },
  Open: {
    name: "Ongoing",
    indicatorClass: "reviewStageOpenIndicator",
    containerClass: "reviewStageOpen",
  },
  Closed: {
    name: "Closed",
    indicatorClass: "reviewStageClosedIndicator",
    containerClass: "reviewStageClosed",
  },
  Revoked: {
    name: "Revoked",
    indicatorClass: "reviewStageRevokedIndicator",
    containerClass: "reviewStageRevoked",
  },
};

export const reviewStagesList: any = [
  {
    text: "Draft",
    value: "Draft",
  },
  {
    text: "Ongoing",
    value: "Open",
  },
  {
    text: "Revoked",
    value: "Revoked",
  },
  {
    text: "Closed",
    value: "Closed",
  },
];

export const entityMapper: any = {
  RESOURCE_TYPE_FILE: {
    args: ["fileVersionId"],
  },
  RESOURCE_TYPE_ESTIMATE: {
    args: ["estimateId", "estimateVersionId"],
  },
  RESOURCE_TYPE_ISSUE: {
    args: ["issueId"],
  },
  RESOURCE_TYPE_TASK: {
    args: ["taskId"],
  },
};

export const defaultReviewNotificationData: any = {
  selectedReviewersAtLevel1: [],
  selectedReviewersFromSpace: [],
  message: "",
};
